(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PackageFeatureList', PackageFeatureList);

    PackageFeatureList.$inject = ['$resource'];

    function PackageFeatureList($resource) {
        var resourceUrl = 'api/package-feature-lists/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
